import { render } from "./AssetItemCard.vue?vue&type=template&id=2c81f9e6&scoped=true&ts=true&lang=pug"
import script from "./AssetItemCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./AssetItemCard.vue?vue&type=script&lang=ts&setup=true"

import "./AssetItemCard.vue?vue&type=style&index=0&id=2c81f9e6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c81f9e6"]])

export default __exports__